<div class="new-manager">
  <div class="main-new-manager">
    <div class="dialog-title-row">
      <h1 class="title-new-manager m-0">Crear sesión</h1>
      <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
    </div>

    <!-- Nombre del evento -->
    <div class="event-info">
      <p class="event-label">Evento:</p>
      <p class="event-name">{{ eventName }}</p>
    </div>

    <form [formGroup]="sessionForm">

      <!-- Toggle Hacer recurrente -->
      <div class="recurring-toggle">
        <label class="custom-toggle">
          <input type="checkbox" formControlName="recurring">
          <span class="toggle-slider"></span>
          <span class="toggle-label">Hacer recurrente</span>
        </label>
        <i class="fa-regular fa-arrows-repeat icon-repeat"></i>
      </div>

      <!-- MODO NORMAL: Lista de sesiones -->
      <div *ngIf="!isRecurring" formArrayName="sessions">
        <div *ngFor="let session of sessions.controls; let i = index" [formGroupName]="i" class="session-item">
          <div class="session-row">
            <!-- Selector de fecha y hora -->
            <div class="form-field datetime-field">
              <app-datetime-selector
                [date]="session.get('date').value"
                [time]="session.get('time').value"
                [dateEventSaved]="session.get('dateString').value"
                (saveDate)="saveDate($event, 'session', i)">
              </app-datetime-selector>
            </div>

            <!-- Checkbox Todo el día -->
            <div class="form-field checkbox-field">
              <mat-checkbox
                formControlName="allDay"
                color="primary"
                (change)="toggleAllDay(i)">
                Todo el día
              </mat-checkbox>
            </div>

            <!-- Botón eliminar -->
            <button
              type="button"
              class="btn-remove"
              *ngIf="sessions.length > 1"
              (click)="removeSession(i)">
              <i class="fa-regular fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- Botón añadir otra sesión -->
        <button type="button" class="btn-add-session" (click)="addSession()">
          <i class="fa-regular fa-plus-circle"></i>
          <span>Añadir otra sesión</span>
        </button>
      </div>

      <!-- MODO RECURRENTE: Configuración de recurrencia -->
      <div *ngIf="isRecurring" class="recurring-config">

        <!-- Iniciar -->
        <div class="form-row">
          <label class="form-label">Iniciar:</label>
          <div class="form-field date-field-recurring">
            <app-datetime-selector
              [date]="sessionForm.get('startDate').value"
              [dateEventSaved]="sessionForm.get('startDateString').value"
              (saveDate)="saveDate($event, 'startDate')">
            </app-datetime-selector>
          </div>
        </div>

        <!-- Repetir cada -->
        <div class="form-row">
          <label class="form-label">
            <i class="fa-regular fa-arrows-repeat icon-repeat-label"></i>
            Repetir cada:
          </label>
          <div class="repeat-fields">
            <input
              type="number"
              class="form-input-number"
              formControlName="repeatEvery"
              min="1">
            <app-card-select class="form-select-repeat" [options]="repeatUnitOptions"
              [value]="sessionForm.get('repeatUnit')!.value"
              (valueChange)="sessionForm.get('repeatUnit')!.setValue($event)">
            </app-card-select>
          </div>
        </div>

        <!-- Días de la semana -->
        <div class="weekdays-selector">
          <div
            *ngFor="let day of weekDays"
            class="weekday-btn"
            [class.selected]="isWeekDaySelected(day.value)"
            (click)="toggleWeekDay(day.value)">
            {{ day.label }}
          </div>
        </div>

        <!-- Mensaje de recurrencia -->
        <div class="recurring-message" *ngIf="selectedDays.length > 0">
          <p>{{ getRecurringMessage() }}</p>
        </div>

        <!-- Fecha fin -->
        <div class="form-row">
          <label class="form-label">Fecha fin:</label>
          <div class="form-field date-field-recurring">
            <app-datetime-selector
              [date]="sessionForm.get('endDate').value"
              [dateEventSaved]="sessionForm.get('endDateString').value"
              (saveDate)="saveDate($event, 'endDate')">
            </app-datetime-selector>
          </div>
        </div>

        <!-- Mensaje informativo -->
        <div class="info-message">
          <i class="fa-regular fa-circle-info"></i>
          <p>Las sesiones se podrán modificar individualmente desde el calendario</p>
        </div>
      </div>

    </form>
  </div>

  <mat-divider></mat-divider>

  <!-- Footer con botones -->
  <div class="footer-new-manager">
    <div class="btn-new btn-create m-0" (click)="saveSession()" [class.disabled]="sessionForm.invalid">
      <p class="m-0">Crear</p>
    </div>
  </div>
</div>
